export enum TicketBannerSize {
	sm = 'sm',
	md = 'md',
	lg = 'lg',
}

/** Max width of the apps narrow container on desktop */
export const MOBILE_CONTAINER_WIDTH = 600;
